import React, {useState, useEffect, useMemo} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';

// import SideBar from '../SideBar';
// import ServerLifecycle from './ServerLifecycle';
import ServerLifecycleChart from './charts/ServerLifecycleChart';
import CameraLifecycleChart from './charts/CameraLifecycleChart';

import { listBusinesses } from '../../redux/actions/listBusinesses';
import { listSites } from '../../redux/actions/listSites';

import { BeatLoader } from 'react-spinners';
import { RingLoader } from 'react-spinners';

import AssetSummaryCards from './assetSummary/AssetSummary';
import { url } from '../../api/endpointURL';
import { webURL } from '../../config';

import '../../../src/styles/lifecycle.css';
import './charts/lifecyclecharts.css';
import './lifecycle.css';

import {Button} from 'react-bootstrap';
import CameraLifecycle from './CameraLifecycle';
import GradedBar from './serverGradedBar/ServerGradedBar';
import ServerLifeExpectancyBar from './serverGradedBar/ServerLifeExpectancyBar';

import { updateServerLifecycle } from '../../redux/actions/updateServerLifecycleAction';
import { canAccess } from '../../config';

// Import generic components
import Select from '../../generic_components/Select/Select';
import Table from '../../generic_components/Table/Table';
import Tooltip from '../../generic_components/Tooltip/Tooltip';
import Modal from '../../generic_components/Modal/Modal';
import Footer from '../../generic_components/Footer/Footer';
import {useToast} from '../../generic_components/Toast/Toast';
import Card from '../../generic_components/Card/Card';


const viewIcon = require('../../images/viewIcon.png');
const alertIcon = require('../../images/alertIcon.png');
const restartIcon = require('../../images/restart.png');




const Lifecycle = () => {

    const [date,setDate] = useState(new Date());   
    const [selectedSite, setSelectedSite] = useState('All');
    const [selectedPeriod, setSelectedPeriod] = useState('365');
    const [selectedServerLifeExpectancyDays, setSelectedServerLifeExpectancyDays] = useState('1095');
    const [selectedCameraLifeExpectancyDays, setSelectedCameraLifeExpectancyDays] = useState('1825');
    const [selectedCriticalDaysServer, setSelectedCriticalDaysServer] = useState('20');
    const [selectedCriticalDaysCamera, setSelectedCriticalDaysCamera] = useState('10');
    const businesses = useSelector(state => state.listBusinesses);
    // sort by business name
    businesses.sort((a, b) => a.localeCompare(b));    
    const [selectedBusiness, setSelectedBusiness] = useState(businesses[0]);
    const [isSwitchOnServerExpired, setIsSwitchOnServerExpired] = useState(false);
    const [isSwitchOnServerCritical, setIsSwitchOnServerCritical] = useState(false);
    const [isSwitchOnServerHealthy, setIsSwitchOnServerHealthy] = useState(false);
    const [isSwitchOnCameraExpired, setIsSwitchOnCameraExpired] = useState(false);
    const [isSwitchOnCameraCritical, setIsSwitchOnCameraCritical] = useState(false);
    const [isSwitchOnCameraHealthy, setIsSwitchOnCameraHealthy] = useState(false);
    const [isSwitchOnServerNoMaintenance, setIsSwitchOnServerNoMaintenance] = useState(false);
    const [sortConfigServerLifecycle, setSortConfigServerLifecycle] = useState({ key: 'operatingDays', direction: 'ascending' });
    const [userBusinessRole, setUserBusinessRole] = useState(null);  

    const serverLifecycleData = useSelector(state => state.listSites);

    const handleSortServerLifecycle = (columnKey) => {
        let direction = 'ascending';
        if (sortConfigServerLifecycle.key === columnKey && sortConfigServerLifecycle.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfigServerLifecycle({ key: columnKey, direction });
    };

    const renderSortIconServerLifecycle = (columnKey) => {
        if (sortConfigServerLifecycle.key === columnKey) {
          return sortConfigServerLifecycle.direction === 'ascending' ? '▲' : '▼';
        }
        // Default to ascending arrow if not sorted yet
        return '▲';
      };

    function calculateDaysPassed(startDateUTC) {
        // Parse the start date as a UTC date
        const start = new Date(startDateUTC);
        // Get the current date in UTC
        const now = new Date();
        // Calculate the difference in milliseconds
        const diffInMilliseconds = now - start;
        // Convert the difference to days
        const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
        return diffInDays;
    }

    let uniqueSites = [...new Set(serverLifecycleData.map(each => each.site?.site))];
    // sort sites alphabetically
    uniqueSites = uniqueSites.sort((a, b) => a.localeCompare(b));

    const loading = useSelector(state => state.loading);
    const loadingServerLifecycleUpdate = useSelector(state => state.loadingServerLifecycleUpdate);

    // insert integere value in an array to store critical days range form 1 to selectedPeriod
    const criticalDaysRange = Array.from({length: 30}, (_, i) => i + 1);    

    // filter sites based on selected one
  const filteredServerLifecycleData =
  selectedSite === 'All'
    ? serverLifecycleData
    : serverLifecycleData.filter((each) =>
        each.site.site === selectedSite
    );


    // sort by server lifecycle days
  let sortedFilteredServerLifecycleData = [...filteredServerLifecycleData].sort(
    (a, b) => calculateDaysPassed(b.serverFirstCheckin) - calculateDaysPassed(a.serverFirstCheckin)
    );



    // toggle for server expired lifecycle
    if (isSwitchOnServerExpired) {
        sortedFilteredServerLifecycleData = sortedFilteredServerLifecycleData.filter(
            each => calculateDaysPassed(each.serverFirstCheckin) > selectedPeriod);
    }

    // toggle for server critical lifecycle
    if (isSwitchOnServerCritical) {
    sortedFilteredServerLifecycleData = sortedFilteredServerLifecycleData.filter(
        each => parseInt(selectedPeriod) - calculateDaysPassed(each.serverFirstCheckin) < parseInt(selectedCriticalDaysServer)
        && parseInt(selectedPeriod) - calculateDaysPassed(each.serverFirstCheckin) > 0);
    }

    // toggle for server healthy lifecycle
    if (isSwitchOnServerHealthy) {
        sortedFilteredServerLifecycleData = sortedFilteredServerLifecycleData.filter(
            each => parseInt(selectedPeriod) - calculateDaysPassed(each.serverFirstCheckin) > parseInt(selectedCriticalDaysServer));
    }

    // toggle for camera expired lifecycle
    if (isSwitchOnCameraExpired) {
        sortedFilteredServerLifecycleData = sortedFilteredServerLifecycleData.filter(
            each => each.cameras.filter(camera => calculateDaysPassed(camera.cameraFirstCheckin) > selectedPeriod).length > 0);
    }
    
    // toggle for camera critical lifecycle
    if (isSwitchOnCameraCritical) {
        sortedFilteredServerLifecycleData = sortedFilteredServerLifecycleData.filter(
            each => each.cameras.filter(camera => parseInt(selectedPeriod) - calculateDaysPassed(camera.cameraFirstCheckin) < parseInt(selectedCriticalDaysCamera)
            && parseInt(selectedPeriod) - calculateDaysPassed(camera.cameraFirstCheckin) > 0).length > 0);
    }

    // toggle for camera healthy lifecycle
    if (isSwitchOnCameraHealthy) {
        sortedFilteredServerLifecycleData = sortedFilteredServerLifecycleData.filter(
            each => each.cameras.filter(camera => parseInt(selectedPeriod) - calculateDaysPassed(camera.cameraFirstCheckin) > parseInt(selectedCriticalDaysCamera)).length > 0);
    }




     // toggle for no maintenance
     if (isSwitchOnServerNoMaintenance) {
        sortedFilteredServerLifecycleData = sortedFilteredServerLifecycleData.filter(
            each => !each.serverLastMaintenance
        );
    }

    // sort by all columns - alert data
    const sortedAllColumnsFilteredServerLifecycle = [...sortedFilteredServerLifecycleData].sort((a, b) => {
        // for server.serverFirstCheckin
        if (sortConfigServerLifecycle.key === 'operatingDays') {
            return sortConfigServerLifecycle.direction === 'ascending' ? calculateDaysPassed(a.serverFirstCheckin) - calculateDaysPassed(b.serverFirstCheckin) : calculateDaysPassed(b.serverFirstCheckin) - calculateDaysPassed(a.serverFirstCheckin);
        }
        // for server.remainingLifeExpectancy
        else if (sortConfigServerLifecycle.key === 'remainingLifeExpectancy') {
            const remainingLifeExpectancyA = parseInt(selectedServerLifeExpectancyDays) - calculateDaysPassed(a.serverFirstCheckin);
            const remainingLifeExpectancyB = parseInt(selectedServerLifeExpectancyDays) - calculateDaysPassed(b.serverFirstCheckin);
            return sortConfigServerLifecycle.direction === 'ascending' ? remainingLifeExpectancyA - remainingLifeExpectancyB : remainingLifeExpectancyB - remainingLifeExpectancyA;
        } 
        else { // for all other columns
        if (a[sortConfigServerLifecycle.key] < b[sortConfigServerLifecycle.key]) {
            return sortConfigServerLifecycle.direction === 'ascending' ? -1 : 1;
        }

        if (a[sortConfigServerLifecycle.key] > b[sortConfigServerLifecycle.key]) {
        return sortConfigServerLifecycle.direction === 'ascending' ? 1 : -1;
        }
        }

        return 0;
    });

    // Server health data
    const totalServers = filteredServerLifecycleData.length;
    const expiredServers = filteredServerLifecycleData.filter(each => calculateDaysPassed(each.serverFirstCheckin) > parseInt(selectedPeriod)).length;    

    const criticalServers = filteredServerLifecycleData.filter(
        each => ( parseInt(selectedPeriod) - calculateDaysPassed(each.serverFirstCheckin) < parseInt(selectedCriticalDaysServer) && parseInt(selectedPeriod) - calculateDaysPassed(each.serverFirstCheckin) > 0)).length;
    
    const healthyServers = totalServers - expiredServers - criticalServers;
    
    // server health chart data
    const serverData = {
        labels: ['Healthy', 'Critical', 'Expired'],
        datasets: [{
          data: [healthyServers, criticalServers, expiredServers],
          backgroundColor: ['#28a745', '#ffc107', '#dc3545'],
          hoverBackgroundColor: ['#218838', '#e0a800', '#c82333']
        }]
    };

    // calculate average operating days of servers
    const totalOperatingDaysServers = filteredServerLifecycleData.reduce((acc, each) => acc + calculateDaysPassed(each.serverFirstCheckin), 0);
    const averageOperatingDaysServers = parseInt(totalOperatingDaysServers / totalServers);
      

    // camera health data
    const totalCameras = filteredServerLifecycleData.reduce((acc, each) => acc + each.cameras.length, 0);
    const expiredCameras = filteredServerLifecycleData.reduce((acc, each) => acc + each.cameras.filter(camera => calculateDaysPassed(camera.cameraFirstCheckin) > parseInt(selectedPeriod)).length, 0);

   
    const criticalCameras = filteredServerLifecycleData.reduce((acc, each) => acc + each.cameras.filter(
        camera => ( parseInt(selectedPeriod) - calculateDaysPassed(camera.cameraFirstCheckin) < parseInt(selectedCriticalDaysCamera) && parseInt(selectedPeriod) - calculateDaysPassed(camera.cameraFirstCheckin) > 0)).length, 0);

    const healthyCameras = totalCameras - expiredCameras - criticalCameras;

    // camera health chart data
    const cameraData = {
        labels: ['Healthy', 'Critical', 'Expired'],
        datasets: [{
          data: [healthyCameras, criticalCameras, expiredCameras],
          backgroundColor: ['#28a745', '#ffc107', '#dc3545'],
          hoverBackgroundColor: ['#218838', '#e0a800', '#c82333']
        }]
    };
    
    // Asset summary data
    const getAggregatedAssetSummary = () =>{
        let reult = {
            total: 0,
            healthy: 0, 
            critical: 0,
            expired: 0
        };
        const healthy = serverData.datasets[0].data[0] + cameraData.datasets[0].data[0];
        const critical = serverData.datasets[0].data[1] + cameraData.datasets[0].data[1];
        const expired = serverData.datasets[0].data[2] + cameraData.datasets[0].data[2];
        const total = healthy + critical + expired;

        reult.total = total;
        reult.healthy = healthy;
        reult.critical = critical;
        reult.expired = expired;

        return reult;
    }

    
    // calculate average operating days of cameras
    const totalOperatingDaysCameras = filteredServerLifecycleData.reduce((acc, each) => acc + each.cameras.reduce((acc, camera) => acc + calculateDaysPassed(camera.cameraFirstCheckin), 0), 0);
    const averageOperatingDaysCameras = parseInt(totalOperatingDaysCameras / totalCameras);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isSmallScreen = window.innerWidth < 600;

    const user = localStorage.getItem('email');

    const handleBusinessChange = (e) => {
        setSelectedBusiness(e.target.value);
        setSelectedSite('All');
    }

    const handleSiteChange = (e) => {
        setSelectedSite(e.target.value);
    }

    const handlePeriodchange = (e) => {
        setSelectedPeriod(e.target.value);
    }

    const handleServerCriticalDays = (e) => {
        setSelectedCriticalDaysServer(e.target.value);
    }

    const handleCameraCriticalDays = (e) => {
        setSelectedCriticalDaysCamera(e.target.value);
    }

    const handleServerLifeExpectancy = (e) => {
        setSelectedServerLifeExpectancyDays(e.target.value);
    }

    const handleCameraLifeExpectancy = (e) => {
        setSelectedCameraLifeExpectancyDays(e.target.value);
    }

    // handle toggle server no mainten
    const handleSwitchChangeServerNoMaintenance = () => {
        setIsSwitchOnServerNoMaintenance(!isSwitchOnServerNoMaintenance);
      };

    useEffect(() => {
        var timer = setInterval(()=>setDate(new Date()), 1000 )
        return function cleanup() {
            clearInterval(timer);
        }
    });

    // fetch businesses tied to the logged user
    useEffect(() => {
       dispatch(listBusinesses(user));   
    }, [dispatch, user]);

   // Memoize the first business
   const firstBusiness = useMemo(() => {
    return businesses.length ? businesses[0] : null;
    }, [businesses]);

    useEffect(() => {
    if (firstBusiness) {
        setSelectedBusiness(firstBusiness);
    }
    }, [firstBusiness]);

    // fetch lifecycledata tied to the selected business
    useEffect(() => {
        if (selectedBusiness) {
            dispatch(listSites({ selectedBusiness, user })); 
        }       
     }, [selectedBusiness, dispatch, user]);

     useEffect(() => {
        if (!user) {
            navigate('/auth/signin');
        }
     }, [navigate, user]);


    // Get the current user level for the business.If rbac = 'tla', user role should be 'tla'
    useEffect(() => {
        let userRole = localStorage.getItem('rbac_role')?.toLowerCase();
        setUserBusinessRole(userRole);
        if (userRole !== 'tla') {
        try {
            // Get the current user level for the business
            const businessRoles = JSON.parse(localStorage.getItem('rbac_data')) || [];
            setUserBusinessRole(businessRoles.find(businessRole => businessRole.business === selectedBusiness)?.role?.toLowerCase());
            } catch (e) {
                console.error('Error parsing rbac_data:', e);
            }
        }
    }, [selectedBusiness])

    // Fetch RBAC business-roles
    const fetchAndStoreRBAC = async (email) => {
        try {
            const url_path = url+'/fetch_rbac'; // Use environment variable or default to localhost
            const response = await fetch(url_path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ user: email })
            });
            
            const rbacResponse = await response.json();
            // console.log("RBAC fetched:", rbacResponse);
        
            // Store in localStorage for persistence
            localStorage.setItem('rbac_role', rbacResponse.global_role);
            localStorage.setItem('rbac_data', JSON.stringify(rbacResponse.business_roles));
            return rbacResponse;
        } catch (error) {
            console.error('Error fetching RBAC data:', error);
        }
    };
    
    // SINGLE useEffect for initialization
    useEffect(() => {
        const email = localStorage.getItem('email');
        
        if (!email) {
            // window.location.href = '/#auth/signin';
            return;
        }
        
        const initializeData = async () => {
            try {
            // Fetch RBAC data first
            await fetchAndStoreRBAC(email);
                
            } catch (error) {
            console.error('Error loading initial data:', error);
            } finally {
            }
        };
        
        initializeData();
    }, []); // Empty dependency array - run once only

    const businessOptions = businesses.map((business, index) => ( 
        {
        label: business,
        value: business
        }
    ));


    const siteOptions = [
        {label: 'All', value: 'all'},
        ...uniqueSites.map((site, index) => (
        {
        label: site,
        value: site
        }
    ))
    ];

    const criticalDaysRangeOptions = criticalDaysRange.map((each, index) => (
        {
            label: `Critical: ${each} days`,
            value: each
        }
    ));

    //                                     ServerLifecycle                    //
    const [showCameraModal, setShowCameraModal] = useState(false);
    const [showWarningModal, setShowWarningaModal] = useState(false);
    const [action, setAction] = useState(false);
    const [selectedServer, setSelectedServer] = useState('');

    const updateServerLifecyclResponse = useSelector(state => state.updateServerLifecycle);
    
    const toast = useToast();
    
    
    // Camera Modal control
    const openCameraModal = (server) => {
        setShowCameraModal(true);
        setSelectedServer(server);
    };
    const closeCameraModal = () => {
        setShowCameraModal(false);
    };

    // Warming Modal
     const openWarningModal = (server, serverLastMaintenance) => {
      if (serverLastMaintenance === 0) {
        const errorMsg = `Maintenance event of server ${server.serverName} was already updated today.`;
        toast.error(errorMsg, {
          hideProgressBar: true,
          autoClose: 9000  
        });
        return;
      }
      setShowWarningaModal(true);
      setSelectedServer(server);
    };

    const closeWarningModal = () => {
        setShowWarningaModal(false);
    };

    const handleResetOperatingTime = (server) => {
        setAction(true);
        const payload = { hwid: server.hwid, server_name:  server.serverName, user: user}
        dispatch(updateServerLifecycle(payload));
        closeWarningModal();
    };
    
    useEffect(() => {
        if (action && updateServerLifecyclResponse.code === 200) {
        const successMsg =`Maintenance event of server ${selectedServer.serverName} is updated.`;
        toast.success(successMsg, {
            hideProgressBar: true,
            autoClose: 9000  
        });
        setAction(false);
        
        }
        if (action && updateServerLifecyclResponse.code === 500) {
        const errorMsg = "Internal server error. Please try after some time.";
        toast.error(errorMsg, {
            hideProgressBar: true,
            autoClose: 9000  
        });
        setAction(false);
        }     
    }, [updateServerLifecyclResponse.code, toast, action, selectedServer.serverName]);

    
    // Headers for lifecyle table
    const lifecycle_columns = [
        {
            key: "serverName",
            label: "Server",
            onClick: () => handleSortServerLifecycle("serverName"),
            icon: renderSortIconServerLifecycle("serverName"),
        },
        {
            key: "operatingDays",
            label: "Total Operating Days",
            onClick: () => handleSortServerLifecycle("operatingDays"),
            icon: renderSortIconServerLifecycle("operatingDays"),
        },
        {
            key: "daysSinceLastMaintenance",
            label: "Total Days Since Last Maintenance",
            onClick: () => handleSortServerLifecycle("daysSinceLastMaintenance"),
            icon: renderSortIconServerLifecycle("daysSinceLastMaintenance"),
        },
        {
            key: "remainingLifeExpectancy",
            label: "Total Remaining Life Expectancy Days",
            onClick: () => handleSortServerLifecycle("remainingLifeExpectancy"),
            icon: renderSortIconServerLifecycle("remainingLifeExpectancy"),
        },
        {
            key: "updateMaintenanceEvent",
            label: "Update Maintenance Event",
        },
        {
            key: "totalCameras",
            label: "Total Cameras",
            onClick: () => handleSortServerLifecycle("totalCameras"),
            icon: renderSortIconServerLifecycle("totalCameras"),
        },
    ];

    const lifecyle_data =  loading ? (
        // Render 5 placeholder rows while loading
        [...Array(5)].map((_, index) =>  (
            {
                serverName: <div className="skeleton skeleton-text" />,
                operatingDays: <div className="skeleton skeleton-text" />,
                daysSinceLastMaintenance: <div className="skeleton skeleton-text" />,
                remainingLifeExpectancy: <div className="skeleton skeleton-text" />,
                updateMaintenanceEvent: <div className="skeleton skeleton-text" />,
                totalCameras: <div className="skeleton skeleton-text" />,
            }
        )))
        : 
        (
            sortedAllColumnsFilteredServerLifecycle.map(server => {
            
                let barColor = 'green';

                // set color for expited servers
                if (calculateDaysPassed(server.serverFirstCheckin) > selectedPeriod) {
                    barColor = 'red';
                }

                // set color for critical servers
                if (parseInt(selectedPeriod) - calculateDaysPassed(server.serverFirstCheckin) < parseInt(selectedCriticalDaysServer)
                && parseInt(selectedPeriod) - calculateDaysPassed(server.serverFirstCheckin) > 0) {
                    barColor = 'orange';
                }

                const serverOperatingDays = calculateDaysPassed(server.serverFirstCheckin);
            
                const serverRemainingLifeExpectancyDays = selectedServerLifeExpectancyDays - serverOperatingDays;

                let  serverLastMaintenance = calculateDaysPassed(server.serverLastMaintenance);
                if (!server.serverLastMaintenance) {
                    serverLastMaintenance = 'No maintenance performed';
                }

                // servers life expectancy bar
                const minServerLifeExpectancy = 0;
                const maxServerLifeExpectancy = selectedServerLifeExpectancyDays;
                const currentServerLifeExpectancy = serverRemainingLifeExpectancyDays;

                return {
                    serverName: server.serverName,
                    operatingDays: (
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '2.5em' }}>{serverOperatingDays}</div>
                            <GradedBar barColor={barColor} />
                            {calculateDaysPassed(server.serverFirstCheckin) > selectedPeriod && (
                            <div>
                                <img
                                src={alertIcon}
                                alt="Alert"
                                style={{ height: '1.6em', marginLeft: '0.5em' }}
                                />
                            </div>
                            )}
                        </div>
                    ),
                    daysSinceLastMaintenance: (
                        <div style={{ display: 'flex' }}>
                            <div >{serverLastMaintenance}</div>
                        </div>
                    ),
                    remainingLifeExpectancy: (
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '2.5em' }}>{serverRemainingLifeExpectancyDays}</div>
                            <ServerLifeExpectancyBar
                                value={currentServerLifeExpectancy}
                                min={minServerLifeExpectancy}
                                max={maxServerLifeExpectancy}
                            />
                            {calculateDaysPassed(server.serverFirstCheckin) >=
                                parseInt(selectedServerLifeExpectancyDays) && (
                                <div>
                                    <img
                                        src={alertIcon}
                                        alt="Alert"
                                        style={{ height: '1.6em', marginLeft: '0.5em' }}
                                    />
                                </div>
                            )}
                        </div>
                    ),
                    updateMaintenanceEvent: (
                        <button className="reset-btn" onClick={() => openWarningModal(server, serverLastMaintenance)} disabled={!canAccess("asset-lifecycle-update-maintenance-server", userBusinessRole)}>
                            <img src={restartIcon} alt="Reset" style={{ height: '1.5em' }} />
                        </button>
                    ),
                    totalCameras: (
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '2em' }}>{server.totalCameras}</div>
                                <button
                                className="view-icon-btn"
                                onClick={() => openCameraModal(server)}
                                >
                                    <Tooltip content="View details" placement='left'>
                                        <img
                                            src={viewIcon}
                                            alt="view"
                                            className="view-icon"
                                            style={{ height: '2em' }}
                                        />
                                    </Tooltip>
                                </button>
                        </div>
                    )
                }})
            )
    
  

  return (
   <div className="modern-lifecycle-container">
    {/* {!isSmallScreen &&
        <div style={{ marginTop: '-3.5em' }}>
            <SideBar />
        </div>
    } */}

    <div className='lifecycle-info-container lifecycle-info-container-center'>
        {/* Modern Header */}
        <div className="modern-header">
            <h1>Asset Lifecycle Analytics</h1>
            <div className="modern-timestamp">
                {date.toLocaleTimeString()}&nbsp;
                {date.toLocaleDateString()}
            </div>
        </div>

        {/* Modern Controls */}
        <div className="modern-controls">
            <div className="modern-control-group">
                <Select
                    label="Select Business Unit"
                    value={selectedBusiness}
                    onChange={handleBusinessChange}
                    options={businessOptions}
                    size='sm'
                    selectStyle={{width: '14rem'}}
                />
                
            </div>
            
            <div className="modern-control-group">
                <Select
                    label="Select Site"
                    value={selectedSite}
                    onChange={handleSiteChange}
                    options={siteOptions}
                    size='sm'
                    selectStyle={{width: '14rem'}}
                />
            </div>

            <div className="modern-control-group">
                <Select 
                    label="Select Lifecycle"
                    value={selectedPeriod} 
                    onChange={handlePeriodchange}
                    options={[
                        {label: "365 days", value:"365"},
                        {label: "180 days", value:"180"},
                        {label: "90 days", value:"90"}
                    ]}
                    size='sm'
                    selectStyle={{width: '14rem'}}
                />
            </div>
        </div>

        {serverLifecycleData.length ? (
            <>
                {(!loadingServerLifecycleUpdate || !loading) ? (
                    <>
                    <AssetSummaryCards data={getAggregatedAssetSummary()} loading={loading}/>
                        {/* Modern Stats Grid */}
                        <div className="modern-stats-grid">
                            {/* Server Card */}
                            <Card className='glass-card' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
                                <div className="modern-stat-card">
                                    <div className="modern-card-header">
                                        <div className="modern-card-title">
                                        {/* <span className='server-icon-container'> 🖥️ </span>Server Assets */}
                                            <i className="fa-solid fa-server" style={{color: "#ffffff"}}></i>Server Assets
                                        </div>
                                    </div>
                                    <div className="modern-config-section">
                                        <div className="modern-config-row">                                       
                                            <Select 
                                                value={selectedCriticalDaysServer} 
                                                onChange={handleServerCriticalDays}
                                                options={criticalDaysRangeOptions}
                                                size='sm'
                                                selectStyle={{width: '11rem'}}
                                            />
                                        </div>
                                        <div className="modern-config-row">                                       
                                            <Select 
                                                value={selectedServerLifeExpectancyDays} 
                                                onChange={handleServerLifeExpectancy}
                                                options={[
                                                    { label: "Life Expectancy: 3 years", value: "1095" },
                                                    { label: "Life Expectancy: 5 years", value: "1825" },
                                                    { label: "Life Expectancy: 4 years", value: "1460" },
                                                    { label: "Life Expectancy: 2 years", value: "730" },
                                                    { label: "Life Expectancy: 1 year", value: "365" }
                                                ]}
                                                size='sm'
                                                selectStyle={{width: '11rem'}}
                                            />
                                        </div>
                                    </div>
                                    <ServerLifecycleChart                                   
                                        data={serverData}
                                        setIsSwitchOnServerExpired={setIsSwitchOnServerExpired}
                                        setIsSwitchOnServerCritical={setIsSwitchOnServerCritical}
                                        setIsSwitchOnServerHealthy={setIsSwitchOnServerHealthy}
                                        averageOperatingDaysServers={averageOperatingDaysServers}
                                        loading={loading}
                                    />
                                </div>
                            </Card>

                            {/* Camera Card */}
                            {totalCameras > 0 && (
                            <Card className='glass-card' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
                                <div className="modern-stat-card">
                                    <div className="modern-card-header">
                                        <div className="modern-card-title">
                                           {/* <span className='server-icon-container'> 📹 </span>Camera Assets */}
                                           <i className="fa-solid fa-camera" style={{color: "#ffffff"}}></i>Camera Assets
                                        </div>
                                    </div>
                                    <div className="modern-config-section">
                                        <div className="modern-config-row">                                           
                                            <Select 
                                                value={selectedCriticalDaysCamera} 
                                                onChange={handleCameraCriticalDays}
                                                options={criticalDaysRangeOptions}
                                                size='sm'
                                                selectStyle={{width: '11rem'}}
                                            />
                                        </div>
                                        <div className="modern-config-row">                                           
                                            <Select 
                                                value={selectedCameraLifeExpectancyDays} 
                                                onChange={handleCameraLifeExpectancy}
                                                options={[
                                                    { label: "Life Expectancy: 5 years", value: "1825" },
                                                    { label: "Life Expectancy: 4 years", value: "1460" },
                                                    { label: "Life Expectancy: 3 years", value: "1095" },
                                                    { label: "Life Expectancy: 2 years", value: "730" },
                                                    { label: "Life Expectancy: 1 year", value: "365" }
                                                ]}
                                                size='sm'
                                                selectStyle={{width: '11rem'}}
                                            />

                                        </div>
                                    </div>
                                    <CameraLifecycleChart 
                                        data={cameraData}
                                        setIsSwitchOnCameraExpired={setIsSwitchOnCameraExpired}
                                        setIsSwitchOnCameraCritical={setIsSwitchOnCameraCritical}
                                        setIsSwitchOnCameraHealthy={setIsSwitchOnCameraHealthy}
                                        averageOperatingDaysCameras={averageOperatingDaysCameras}
                                        loading={loading}
                                    />
                                </div>
                            </Card>
                            )}
                        </div>
                       
                        

                        {/* Modern Table */}
                        <div className="modern-table-container">
                            <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
                                <div className="modern-table-header">
                                    <div className="modern-table-title">Asset Inventory & Lifecycle Status</div>
                                        <div className="modern-switch-container">
                                            <div className="modern-maintenance-badge">
                                                <Form>
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="No Maintenance"
                                                        checked={isSwitchOnServerNoMaintenance}
                                                        onChange={handleSwitchChangeServerNoMaintenance}
                                                    />
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                <div >

                                <Table 
                                    columns={lifecycle_columns}
                                    data={lifecyle_data}
                                    className='lifecycle-table'
                                />
                                </div>
                            </Card>
                        </div>
                        </>
                ) : (
                    <div className="modern-loading-container">
                        <BeatLoader size={14} color="white"/>
                    </div>
                )}
            </>
        ) : (
            loading ? (
                <div className="modern-loading-container">
                    <RingLoader size={!isSmallScreen ? 300 : 200} color="#F49523"/>
                </div>
            ) : (
                <div className="modern-no-record">
                    No record found for the selected business {selectedBusiness}!
                </div>
            )
        )}
    </div>

    {/* modal to view cameras lifecycle data modal*/}
    <Modal size='xl' show={showCameraModal} onHide={closeCameraModal} position='center'>
        <Modal.Header closeButton>
            <Modal.Title>Cameras Lifecycle for server: <span className='cameras-modal-title-servername'>{selectedServer.serverName}</span></Modal.Title>
        </Modal.Header>

        <Modal.Body>         
            <CameraLifecycle 
                cameras={selectedServer.cameras}
                selectedPeriod={selectedPeriod}
                serverName={selectedServer.serverName}
                selectedCameraLifeExpectancyDays={selectedCameraLifeExpectancyDays}
                selectedCriticalDaysCamera={selectedCriticalDaysCamera}
                serverOperatingDays={calculateDaysPassed(selectedServer.serverFirstCheckin)}
                userBusinessRole={userBusinessRole}
                />        
        </Modal.Body>
    </Modal>

    {/* Warning Modal*/}
    <Modal size='sm' show={showWarningModal} onHide={closeWarningModal}  >
        <Modal.Header closeButton>
          <Modal.Title>Server Maintenance</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <div>Are you sure you want to confirm maintenance event for server <span style={{ color: 'orange' }}>{selectedServer.serverName}</span> ?</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                <Button variant="danger" size='small' onClick={() => handleResetOperatingTime(selectedServer)}>Yes</Button>
                <Button variant="ghost" size='small' onClick={closeWarningModal}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>

    <div className='footer-lifecycle-container'>
        <Footer url={webURL}/>
    </div>
</div>
  )
}

export default Lifecycle